import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";

import { Rol, User, UserSession, Workgroup } from "../interfaces/user.interface";
import { environment } from "src/environments/environment";

@Injectable({providedIn: 'root'})
export class UserService {

    private url: string = `${environment.url}/workgroup-management`;
    private urlUserManagement: string = `${environment.url}/user-management`;
    private user: User;
    private rolUser?;
    private users: User[];
    private keycloackId?;

    constructor( private http: HttpClient ) {}

    get rol(): string | undefined {
        this.rolUser = sessionStorage.getItem('rol');
        return this.rolUser;
    }

    get keyId(): string | undefined {
        this.keycloackId = sessionStorage.getItem('kcUserId');
        console.log(this.keycloackId);
        return this.keycloackId;
    }

    get usersList():User[] {
        return this.users;
    }

    getUser(): Observable<User> {
        const options = {
            params: {
                "kcId": sessionStorage.getItem('kcUserId'),
            }
        }
        return this.http.get<User>(`${ this.url }/get-user-basic-info`, options);
    }

    getUsers(): Observable<User[]> {
        const options = {
            params: {
                "kcId": sessionStorage.getItem('kcUserId')
            }
        }
        return this.http.get<User[]>(`${ this.url }/get-users-workgroups-info-list`, options);
    }

    getlistUsers():void {
        this.getUsers()
            .subscribe({
                next: (response) => {
                console.log(response);
                this.users = response;
                }
            })
    }

    getWorkgroups(): Observable<Workgroup[]> {
        const options = {
            params: {
                "kcId": sessionStorage.getItem('kcUserId')
            }
        }
        return this.http.get<Workgroup[]>(`${ this.url }/get-account-workgroups-list`, options);
    }

    getLastSession(id):Observable<UserSession>{
      return this.http.get<UserSession>(`${ this.urlUserManagement }/get-current-session-status?accountId=${id}`);
    }

    changeSessionStatus(id,status):Observable<UserSession>{
      return this.http.post<UserSession>(`${ this.urlUserManagement }/change-session-status/${id}`,{"status":status});
    }

}
